import * as api from "./api";

export const getCustomerGuid = function () {
	if (dataLayer[0].shoptet.customer.guid === undefined) return null;
	return dataLayer[0].shoptet.customer.guid;
}

export const  getCustomerFullName = function () {
	if (dataLayer[0].shoptet.customer.fullName === undefined) return null;
	return dataLayer[0].shoptet.customer.fullName;
}

export const  getCustomerEmail = function () {
	if (dataLayer[0].shoptet.customer.email === undefined) return null;
	return dataLayer[0].shoptet.customer.email;
}

export const isLogged = function () {
	return getCustomerGuid() !== null;
}

var getCustomerChildren = function () {
	return api.getData(
		'get-children',
		{'guid': getCustomerGuid()},
		{ async: false }
	).responseJSON;
}